import { useEffect, useMemo, useState } from "react";

import { getCustomerDetail } from "V2.0/services/customer";

export enum UserAccessLevel {
  WHITELABELOWNER = "WHITELABELOWNER",
  WHITELABELUSER = "WHITELABELUSER",
  WHITELABELOPERATOR = "WHITELABELOPERATOR",
  WHITELABELVIEWER = "WHITELABELVIEWER",
}

type CustomerModel = {
  userId: string;
  name: string;
  isCompanyOwner: boolean;
  companyId: string;
  showBilling: boolean;
  email: string;
  userAccessLevel: UserAccessLevel;
  whitelabelOwner: {
    _id: string;
    assistantsPerWorkspace?: number;
    workspacesAllowed?: number;
  };
  applicationSectionsVisible: [];
  assistantSectionsVisible: [];
};

export type CustomerViewModel = CustomerModel & {
  isLoading: boolean;
  isOwner: boolean;
};

export function isCustomerOwner(customer) {
  return (
    customer?.userAccessLevel === UserAccessLevel.WHITELABELOWNER ||
    customer?.userAccessLevel === "OWNER"
  );
}

export default function useCustomer(): CustomerViewModel {
  const [customerDetails, setCustomerDetails] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  async function getCustomerDetails() {
    try {
      const response = await getCustomerDetail();

      if (response.status === 200) {
        setCustomerDetails(response.data);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getCustomerDetails();
  }, []);

  const value = useMemo(() => {
    return {
      isOwner: isCustomerOwner(customerDetails),
      userId: customerDetails?.user,
      ...customerDetails,
      isLoading,
      name: `${customerDetails?.firstName} ${customerDetails?.lastName}`
    };
  }, [customerDetails, isLoading]);

  return value;
}
